import { useState } from "react";
import {
  ToolbarButton,
  Dialog,
  DialogSurface,
  DialogTitle,
  DialogBody,
  DialogActions,
  DialogTrigger,
  Button,
  DialogContent,
  useToastController,
  Dropdown,
  Option,
} from "@fluentui/react-components";
import { useGlobalStatus } from "../../services/GlobalStatusProvider";
import { TOASTER_ID } from "../../services/toastUtils";
import { showErrorToast } from "../../services/toastUtils";
import { GetA23Users, changeUser } from "../../services/apiService";

export default function UserSelector() {
  const [open, setOpen] = useState(false);
  const { useStyles, startLoad, endLoad }= useGlobalStatus();
  const styles = useStyles();
  const { dispatchToast } = useToastController(TOASTER_ID);
  const [data, setData] = useState([]);

  const [selectedValue, setSelectedValue] = useState('');

  const selectUser = async (userEmail) => {
    await changeUser(userEmail);
    setOpen(false);
  }

  const openSelectUser = async () => {
    try {
      startLoad();
      try {
        setData([]);
        const response = await GetA23Users();
        setData(response);
      } catch {
        showErrorToast(dispatchToast, "Failed to get timecodes");
      }
      endLoad();
      setOpen(true);
    } catch (ex) {
      console.error(ex);
      endLoad();
    }
  };

  return (
    <div>
      <Dialog open={open} onOpenChange={(e, { open }) => setOpen(open)} >
        <DialogTrigger>
          <ToolbarButton 
          className={styles.buttonPrimary}
          onClick={()=> {openSelectUser()}}>
            Change User
          </ToolbarButton>
        </DialogTrigger>

        <DialogSurface style={{ width: '90vw', maxWidth: '1200px' }}>
          <DialogBody>
            <DialogTitle>Select a User</DialogTitle>
            <DialogContent>
              <div>Choose a user you want to impersonate, you will need to restart the app or change the value back to yourself to reset back to your timesheets.</div>
              <Dropdown
                placeholder="Choose an option..."
                value={selectedValue}
                onOptionSelect={(_, d) => {
                  // data.optionValue gives you the selected string directly
                  if (d.optionValue) {
                    setSelectedValue(d.optionValue);
                  }
                }}
              >
                {data.map((item) => (
                  <Option key={item} value={item}>
                    {item}
                  </Option>
                ))}
              </Dropdown>
              {selectedValue && <p>You selected: {selectedValue}</p>}
            </DialogContent>
            <DialogActions>
              <Button className={styles.buttonPrimary}
                onClick={() => {
                    selectUser(selectedValue);
                }}>Confirm</Button>
              <Button appearance="secondary" onClick={() => setOpen(false)}>
                Close
              </Button>
            </DialogActions>
          </DialogBody>
        </DialogSurface>
      </Dialog>
    </div>
  );
}
